import { forwardRef } from 'react';
import CheckboxInternal from './checkbox-internal';
const Checkbox = forwardRef(CheckboxInternal);
export default Checkbox;
